export const COM_ETH_IC_CONSTRUCTION_DEFAULT_TOLERANCE_RATE = 0.1;

export interface ProjectCstbIndicatorsParameters {
  comEthIcConstructionToleranceRate?: number;
  re2020ThresholdYear?: string;
}
